<div class="layout-topbar">
    <a class="layout-topbar-logo" routerLink="['/']">
        <img style="max-height: 50px; object-fit: contain;" width="60px" [src]="apiConselhoBola" alt="logo">
        <img style="max-height: 50px; object-fit: contain;" [src]="getUrlImagemLogo()" alt="logo">
    </a>

   <button #topbarmenubutton class="p-link layout-menu-button layout-topbar-button" (click)="layoutService.onMenuToggle()">
    <i class="pi pi-bars"></i>
    </button>

    <!-- <button #topbarmenubutton class="p-link layout-topbar-menu-button layout-topbar-button" (click)="layoutService.showProfileSidebar()">
        <i class="pi pi-ellipsis-v"></i>
    </button> -->

    <div #topbarmenu class="layout-topbar-menu" >
        <div style="display: flex; flex-direction: column; align-items: center;">
             <span class="text-white font-medium">{{getDescricaoConselho()}}</span>
             <app-session-counter class="session-counter"></app-session-counter>
        </div>
        
        <button class="p-link layout-topbar-button flex items-center" pTooltip="Logout"  tooltipPosition="top"(click)="logout()"> 
            <i class="pi pi-sign-out"></i>
        </button>
    </div>
</div>